import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {FormControl} from '@angular/forms';
import {fadeIn} from "../../../../animations/basic-animation";
import {ROUTE_ANIMATIONS_ELEMENTS} from "../../../../animations/router-animation";

@Component({
  selector: 'app-top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss'],
  animations: [fadeIn]
})
export class TopBannerComponent implements OnInit {
  @Input() title = '';
  @Input() addButtonName = 'Create';
  @Input() image = '';
  @Input() url = '';
  @Input() useBackButton = true;
  @Input() useDropdownOnCreate = false;
  @Input() showHelp = false;
  @Input() hideAdd = true;
  @Input() viewDetails = false;
  @Input() loading = false;
  @Input() addPermission: string[] = [];
  @Input() menuItems: any[] = [];
  @Input() dropMenuOnCreate: any = [];
  @Input() billsFiltering: any = [];
  @Input() breadcrumbs: any[] = [];
  @Output() addClicked = new EventEmitter();
  @Output() onButtonMenuAction = new EventEmitter();
  @Output() onBillsFilter = new EventEmitter();
  flt: any [] = [];

  searchControl = new FormControl('');

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;


  constructor(private location: Location, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.url.subscribe(params => {
      try {
        if (params.length > 1) {
          const path = params[0].path;
          // this.title = this.sanitizeParentTitle(path) + ' / ' + this.title;
        }
      } catch (e) {

      }
    });

  }


  sanitizeParentTitle(path: string) {
    path = path.replace(/-/gi, ' ').replace(/\b\w/g, l => l.toUpperCase());
    return path.charAt(0).toUpperCase() + path.substring(1, path.length);
  }

  add() {
    this.addClicked.emit();
  }

  buttonMenuAction(event: any) {
    this.onButtonMenuAction.emit(event);
  }

  goBack() {
    this.location.back();
  }

}
